import { render } from "./snackbar-component.vue?vue&type=template&id=19a08c12&ts=true"
import script from "./snackbar-component.vue?vue&type=script&lang=ts"
export * from "./snackbar-component.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__